import script from "./StudentDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDetails.vue?vue&type=script&setup=true&lang=js"

import "./StudentDetails.vue?vue&type=style&index=0&id=1f086cea&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f086cea"]])

export default __exports__